import MintableList from "./MintableList";

export default MintableList;